export default {
    'doc-SxS-itemAttachment': {},
    'doc-SxS-saveToCloud': {},
    'doc-SxS-pdfJsPreview': {},
    'doc-SxS-pdfJsPreviewDefaultInFirefox': {},
    'doc-SxS-printPdf': {},
    'doc-SxS-printImage': {},
    'doc-SxS-refactor': {},
    'doc-SxS-V2': {},
    'doc-attachment-upsellEntryPoint': {},
    'doc-attachment-slicedClassicAttachmentUpload': {},
    'doc-attachment-composeDropHint': {},
    'doc-attachment-dragDropAttachments': {},
    'doc-attachment-convertCloudyToClassic': {},
    'doc-attachment-convertClassicToCloudy': {},
    'doc-attachment-convoWell': {},
    'doc-attachment-expiringLinkImprovements': {},
    'doc-attachment-sharingDialog': {},
    'doc-attachment-sharingTips': {},
    'doc-attachment-sharingInfoFailureTip': {},
    'doc-attachment-throttleThumbnails': {},
    'doc-attachment-traceAttachmentModelLifeTime': {},
    'doc-attachment-includeMostRecentAttachments': {},
    'doc-fileshub-searchbox': {},
    'mc-moveAttachmentToInline': {},
    'doc-SharePoint-dogfoodUser': {},
    'doc-attachment-documentThumbnail': {},
    'doc-attachment-sharingLinkInfoOWSPrimeService': {},
    'doc-sharingTips-recipientBasedPermissionCheck': {},
    'doc-beautify-link': {},
};
//# sourceMappingURL=attachmentFeatures.js.map